import { useState, useEffect } from "react";

/**
 * useDebounce
 * @param value - the value to debounce
 * @param delay - debounce delay in ms (default 500ms)
 * @returns debounced value
 */
export default function useDebounce(value, delay = 500) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Cleanup on value change or unmount
    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
}
